define('app-Agents/modules/common/settings',[],function () {
    return {
        container: ".agents"
        }
});
